import { APP_VERSION } from './version';

export const environment = {
  production: false,
  API_URL: "https://oshomolog.acto.net.br",
  API_URL_CMS: 'https://cms-api-dev.acto.net.br',
  API_NLWEB: 'https://nlweb-demo-app.azurewebsites.net',
  imagemBanner: '/assets/images/banner.jpg',
  logoPrefeitura: '/assets/svg/logoGier.svg',
  version: APP_VERSION,
  environmentName: 'api-dev',
  googleAnalyticsKey: 'G-D9BYRZT69Z'
};
